import { createSlice } from "@reduxjs/toolkit";

export const counterSlice = createSlice({
  name: "user",
  initialState: {
    token: "",
    data: {},
    list: [],
  },
  reducers: {
    loadUser: () => {},
    loadUserSuccess: (state, action) => {
      state.data = action.payload.data;
    },
    removeUser: () => {},
    loadUsers: () => {},
    loadUsersSuccess: (state, action) => {
      state.list = action.payload.data;
    },
    login: () => {},
    loginSuccess: (state, action) => {
      state.token = action.payload.data.token;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    logout: (state) => {
      state.token = "";
      state.data = {};
      state.list = [];
    },
    addUser: () => {},
    loadLocalUser: () => {},
    loadUserList: () => {},
    loadUserListSuccess: (state, action) => {
      state.list = action.payload.data;
    },
  },
});

export const {
  loadUser,
  setToken,
  loadUserSuccess,
  loadUsers,
  loadUsersSuccess,
  login,
  loginSuccess,
  loadLocalUser,
  loadUserList,
  loadUserListSuccess,
  logout,
  addUser,
  removeUser,
} = counterSlice.actions;

export default counterSlice.reducer;

export const getToken = (state) => state.user.token;

export const getUser = (state) => state.user.data;

export const getUserList = (state) => state.user.list;

export const isLoggedIn = (state) => state.user.data.email !== undefined;
